module.exports = __webpack_public_path__ + "img/164.0ee1264e.svg";